document.addEventListener('DOMContentLoaded', function() {
  var scrollContainer = document.querySelector('.d4-mobile-nav .d6-reviews-container');
  var progressBar = document.querySelector('.d4-mobile-nav .track-d6-navbar-1');
  var nextButton = document.querySelector('.d4-mobile-nav .slide-button-nav-d6-right');
  var prevButton = document.querySelector('.d4-mobile-nav .slide-button-nav-d6-left');
  var slides = document.querySelectorAll(".d4-mobile-nav .d6-menu-review");
  var steps = slides.length;
  var totalSteps =  steps; // Total number of steps for the progress bar
  var currentStep = 1; // Start with the first step already filled

  function updateProgressBar() {
      var width = (currentStep / totalSteps) * 100; // Calculate the progress bar width based on total steps
      progressBar.style.width = width + '%';
  }

  function calculateCurrentStep() {
      var stepSize = (scrollContainer.scrollWidth - scrollContainer.clientWidth) / (totalSteps - 1);
      currentStep = Math.round(scrollContainer.scrollLeft / stepSize) + 1;
      updateProgressBar();
  }

  function smoothScrollBy(distance, duration) {
      var initialScrollPosition = scrollContainer.scrollLeft;
      var startTime = performance.now();

      function scrollStep(timestamp) {
          var timeElapsed = timestamp - startTime;
          var progress = Math.min(timeElapsed / duration, 1);
          scrollContainer.scrollLeft = initialScrollPosition + distance * progress;

          if (timeElapsed < duration) {
              window.requestAnimationFrame(scrollStep);
          } else {
              calculateCurrentStep();
          }
      }

      window.requestAnimationFrame(scrollStep);
  }

  nextButton.addEventListener('click', function() {
      smoothScrollBy((scrollContainer.scrollWidth - scrollContainer.clientWidth) / (totalSteps - 1), 300);
  });

  prevButton.addEventListener('click', function() {
      smoothScrollBy(-(scrollContainer.scrollWidth - scrollContainer.clientWidth) / (totalSteps - 1), 300);
  });

  scrollContainer.addEventListener('scroll', calculateCurrentStep);
  updateProgressBar();
});